<template>
  <div class="modal-card">
    <header class="modal-card-head">
      <p class="modal-card-title">Stats</p>
    </header>
    <section class="modal-card-body">
      <b-table :data="tableData">
        <template slot-scope="props">
          <b-table-column field="status" label="State">
            <span v-if="props.row.status === 'empty'" class="tag">Empty</span>
            <span v-else-if="props.row.status === 'wip'" class="tag is-warning"
              >WIP</span
            >
            <span
              v-else-if="props.row.status === 'finished'"
              class="tag is-success"
              >Finished</span
            >
          </b-table-column>
          <b-table-column field="val" label="Number">{{
            props.row.val
          }}</b-table-column>
        </template>
      </b-table>
    </section>
    <footer class="modal-card-foot">
      <button class="button" type="button" @click="$parent.close()">
        Close
      </button>
    </footer>
  </div>
</template>

<script>
import _ from "lodash";
import useProjectFloorplans from "@/composables/useProjectFloorplans";
import useSnackbar from "@/composables/useSnackbar";
import ui from "@/store/modules/ui";
import { onMounted, ref, reactive, computed } from "@vue/composition-api";

export default {
  props: {
    filters: Object
  },
  setup(props) {
    // Composables
    const { open: openSnack } = useSnackbar();
    const { fetch: fetchFloorplans } = useProjectFloorplans(
      ui.selectedProjectId,
      {
        initialize: false
      }
    );
    // Ui States
    const loading = ref(false);
    const stat = reactive({
      empty: 0,
      wip: 0,
      finished: 0
    });
    const tableData = computed(() => {
      return Object.entries(stat).map(([k, v]) => {
        return {
          status: k,
          val: v
        };
      });
    });
    // Initialization
    onMounted(async () => {
      loading.value = true;
      let res = {};
      try {
        const preres = await fetchFloorplans(1, {
          perPage: 1,
          filters: props.filters
        });
        res = await fetchFloorplans(1, {
          perPage: preres.totalDocs,
          filters: props.filters
        });
      } catch (err) {
        console.error(err);
        openSnack("Failed to Access Server.");
      }
      const counts = _.countBy(res.docs, o => o.status);
      Object.assign(stat, counts);
    });

    return {
      loading,
      stat,
      tableData
    };
  }
};
</script>

